import { render, staticRenderFns } from "./RegistroSucesso.vue?vue&type=template&id=5f625d66&scoped=true"
import script from "./RegistroSucesso.vue?vue&type=script&lang=js"
export * from "./RegistroSucesso.vue?vue&type=script&lang=js"
import style0 from "./RegistroSucesso.vue?vue&type=style&index=0&id=5f625d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f625d66",
  null
  
)

export default component.exports